import Gravity from "./Gravity.js";

export default class ResponsiveProps
{
    // params:
    //     {
    //         x: {gravity: 0.5, using: "width"},
    //         y: { gravity: 1, using: "height"}
    //     },
    get params ()
    {
        return this.m_params;
    }

    set params (val)
    {
        this.m_params.ingest(val);
    }

    constructor (props)
    {
        this.m_params = new Gravity(props.params);
        this.anchor = props.anchor;
        this.scale = props.scale;
    }
}